import { render } from "./PasswordResetPage.vue?vue&type=template&id=5451d8b2&scoped=true"
import script from "./PasswordResetPage.vue?vue&type=script&lang=ts"
export * from "./PasswordResetPage.vue?vue&type=script&lang=ts"

import "./PasswordResetPage.vue?vue&type=style&index=0&id=5451d8b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5451d8b2"

export default script